import React from 'react';

const FpsDetailsUpdate = ({ data, onBack }) => {
  const { message, fps_id, device_id, success_list } = data || {};
  let i = 1;

  if (!data) {
    return null;
  }

  return (
    <div id="wrapper">
      <div className="wrapper row3">
        <div id="container">
          <div align="center">
            <br/><br/><br/><br/><br/><br/><br/><br/><br/>
            <div align="center">
             <div
  className="response"
  dangerouslySetInnerHTML={{
    __html: (message || '').replace(/for D\b/g, 'for Dealer')
  }}
></div>

            </div>

            {success_list && success_list.length > 0 ? (
              <>
                <br/>
                <table width="60%">
                  <tbody>
                    <tr className="tableheader">
                      <td colSpan="2">
                        FPS Details {fps_id} (Device Id : {device_id || 'NA'})
                      </td>
                    </tr>
                    <tr className="tableheader">
                      <td>Sl No</td>
                      <td>Device Id</td>
                    </tr>
                    {success_list.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.deviceId || 'NA'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <div className='response' style={{ marginTop: '20px', color: '#666' }}>
                No details available for this FPS.
              </div>
            )}
            <br/><br/>
            <button onClick={onBack} className="button button2">&larr; Back</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FpsDetailsUpdate;